var map = {
	"./bomba-autocebante.png": 9064,
	"./bomba-cloacal.png": 6574,
	"./bomba-industrial.png": 2240,
	"./bomba-solar.png": 2258,
	"./bomba-sumergible.png": 9278,
	"./bombas-servicio.jpg": 6806,
	"./bombas-servicio.png": 7346,
	"./cerrar.webp": 4896,
	"./correo-electronico.webp": 9279,
	"./facebook.png": 7359,
	"./facebook.webp": 6711,
	"./img-seccion.png": 277,
	"./img-seccion.webp": 3255,
	"./instagram.png": 9719,
	"./intro-bg.png": 1209,
	"./intro-bg.webp": 4557,
	"./logo-blanco.png": 8080,
	"./logo-negro.png": 4250,
	"./nosotros.jpg": 8804,
	"./perforaciones-logo.png": 8527,
	"./perforaciones-servicio.jpg": 1938,
	"./perforaciones-servicio.png": 3142,
	"./social.png": 34,
	"./social.webp": 4724,
	"./telefono.webp": 2535,
	"./ubicacion.webp": 3130,
	"./whatsapp.webp": 8017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;